import { createStyles, DraftsIcon, Theme, WithStyles, withStyles } from '@freighthub/silhouette-core'
import { Component } from 'react'
import { I18N } from 'utils/localisation'

interface ActivityFeedEmptyMessageProps {
  type: 'no-activities' | 'no-activities-for-current-filters'
}

const styles = (theme: Theme) =>
  createStyles({
    messageContainer: {
      height: '30vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.sidebar.default,
    },
    draftsIcon: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      marginBottom: theme.spacing(2.5),
      color: theme.palette.sidebar.default,
    },
  })

class LeanActivityFeedEmptyMessage extends Component<ActivityFeedEmptyMessageProps & WithStyles<typeof styles>> {
  render() {
    const { classes } = this.props
    return (
      <div className={classes.messageContainer}>
        <DraftsIcon className={classes.draftsIcon} />
        <I18N
          term={
            this.props.type === 'no-activities-for-current-filters'
              ? 'activity-feed_empty_for_current_filters-message'
              : 'activity-feed_empty-message'
          }
        />
      </div>
    )
  }
}
export const ActivityFeedEmptyMessage = withStyles(styles)(LeanActivityFeedEmptyMessage)
